require('./cardManageOptionsButton.scss');

const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ components
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;

class CardManageOptionsButton extends React.Component {
    buildMoreOptions() {
        const {
            cardId,
            flagBasedFeatures,
            optionsVisible
        } = this.props;

        const budgetEnabledFlag = flagBasedFeatures.get("budget", false) && optionsVisible.budgets;
        const choreEnabledFlag =  flagBasedFeatures.get("chores", false) && optionsVisible.chores;

        let options = [
            {
                visible: budgetEnabledFlag,
                link: `/myprofile/cards/${cardId}/budgets`,
                text: formatText('cardManageOptions-expenseAndBudget')
            },
            {
                visible: choreEnabledFlag,
                link: `/myprofile/cards/${cardId}/chores`,
                text: formatText('cardManageOptions-chore')
            }
        ];

        return options;
    }

    render() {
        const moreOptions = this.buildMoreOptions();
        const targetElement = (
            <OKButton
                modifier="primary"
                rightIcon="icon-dropdown-abrir"
                smallRightIcon={true}
            >
                <FormattedText value="cards-manageOptions" />
            </OKButton>
        );

        return (
            <span className="card-manage-options-button">
                <PopoverMenu
                    overflow={{ adjustX: true, adjustY: false }}
                    target={targetElement}
                    items={moreOptions}
                    hasArrow={false}
                    placement="bottom"
                />
            </span>
        );
    }
}

CardManageOptionsButton.propTypes = {
    cardId: PropTypes.string.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    optionsVisible: PropTypes.object
};

CardManageOptionsButton.defaultProps = {
    optionsVisible: {
        budgets: true,
        chores: true
    }
};

module.exports = CardManageOptionsButton;
